import React from "react";
import { Link } from 'react-router-dom';

// Material-UI
import { Button, Container, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Card from "@material-ui/core/Card";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  section: {
    margin: theme.spacing(2, 0),
  },
  paper: {
    padding: theme.spacing(3)
  },
  link: {
    textDecoration: "none",
    color: "white",
  },
  title: {
    marginBottom: theme.spacing(3)
  }
}));

const InformasiKelulusan = ({ classes }) => {
  return (
    <section id="informasi-kelulusan">
      <Container>
        <Card className={classes.section} elevation={3}>
          <Alert variant="filled" severity="success">
            <AlertTitle>{"Selamat Anda dinyatakan LULUS!"}</AlertTitle>
            <Typography variant="body2">
              {"Dalam kegiatan Penerimaan Calon Anggota Baru KSR PMI Unit UNJ 2020, dengan predikat A dan NTA 20.27.001 dengan status Anggota"}
            </Typography>
          </Alert>
        </Card>
      </Container>
    </section>
  );
};

const UnduhSertifikat = ( {classes} ) => {
  return (
    <section id="sertifikat-kelulusan">
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Paper elevation={5} className={classes.paper}>
              <Typography variant="h5" align="center" gutterBottom className={classes.title}>
                {"Sertifikat Kelulusan"}
              </Typography>
              <Link to="/doc/sertifikatKelulusan.pdf" target="_blank" className={classes.link}>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  fullWidth
                >
                    {"Unduh Sertifikat Kelulusan"}
                </Button>
              </Link>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
          <Paper elevation={5} className={classes.paper}>
              <Typography variant="h5" align="center" className={classes.title}>
                {"Kartu Tanda Anggota"}
              </Typography>
              <Link to="/doc/kartuTandaAnggota.pdf" target="_blank" className={classes.link}>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  fullWidth
                >
                    {"Unduh Kartu Tanda Anggota"}
                </Button>
              </Link>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

const UserStatusKelulusan = () => {
  const classes = useStyles();

  return (
    <section id="status-kelulusan" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Status Kelulusan" />
          <InformasiKelulusan classes={classes} />
          <UnduhSertifikat classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserStatusKelulusan;
